var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"setting-main-wrapper"},[_c('div',{staticClass:"shop-side p-3 w-100 h-100",staticStyle:{"top":"0","left":"0"}},[_c('NotFound')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }